export default {
  audio: 'audio',
  discussion: 'discussion',
  embed: 'embed',
  embedcode: 'fa-code',
  embedlink: 'fa-link',
  file: 'file',
  fillin: 'fill',
  h5p: 'H5P',
  heading: 'header',
  image: 'image',
  likert: 'likert',
  list: 'list',
  mathjax: 'tex',
  multiplechoice: 'task-list',
  numericquestion: 'numeric',
  openquestion: 'question',
  pagebreak: 'page-break',
  pre: 'code',
  quote: 'quote',
  raw: 'iframe',
  scorm: 'fa-cloud-upload-alt',
  sequencing: 'sort',
  singlechoice: 'task-list-alt',
  table: 'table',
  task: 'task',
  text: 'text',
  video: 'video'
};
